import React, {useEffect} from 'react';
import {useStore} from '@/app/providers/StoreProvider';
import {observer} from 'mobx-react-lite';
import {Flex} from 'antd';
import {Stage} from '@pixi/react';
import {LuckyCanvas} from '@/entities/lucky/ui/LuckyCanvas';
import {useWindowSize} from '@/shared/hooks/useWindowSize';
import {fetchReferralWheelLink} from '@/shared/api/api';
import {handleInvite} from '@/shared/utils/referralLink';

import {numWord} from '@/shared/utils/numWord';
import {Loading} from '@/shared/ui/Loading';
import {MyTimer} from '@/shared/ui/MyTimer';

import ImgPlus from '@/shared/pictures/plus.svg';
import {getDevice} from "@/shared/utils/window";
import {LUCKY_LAYOUT,AREA} from "@/entities/lucky/model/luckyLayout";

export const LuckyPage = observer(() => {

    const size = useWindowSize();
    const device =  getDevice();
    const {luckyStore, userStore} = useStore();


    const wheelRemainingTime = userStore.gameInfo.user.wheelRemainingTime
    const isWheel = userStore.gameInfo.user.wheel > 0;
    const wheel = userStore.gameInfo.user.wheel;
    const word = numWord(wheel, ['Вращение', 'Вращения', 'Вращений']);

    useEffect(() => {

        const fetchLink = async () => {
            const link = await fetchReferralWheelLink();
            if (link.success) {
                luckyStore.referralLink = link.data;
            }
        }
        fetchLink();
    }, []);


    const baseW = AREA.baseWidth;
    const baseH = AREA.baseHeight;

    const availableWidth = size.width - LUCKY_LAYOUT.padding;
    const availableHeight = size.height - (device == 'mobile'?LUCKY_LAYOUT.topPadding:0) - LUCKY_LAYOUT.bottomPadding;

    const scaleX = availableWidth / baseW;
    const scaleY = availableHeight / baseH;

    const scale = Math.min(scaleX, scaleY);

    const stageWidth = baseW * scale;
    const stageHeight = baseH * scale;

    useEffect(() => {
        luckyStore.scale = scale;
        AREA.width = stageWidth;
        AREA.height = stageHeight;

        luckyStore.initGame();
    }, [size.height, size.width]);

    if (userStore.loadingUser) return <Loading/>

    return (

        <div className='lucky-page'>
            <div className="container">
                <h1 className='lucky-page_title'>Клюшка удачи</h1>

                <Stage
                    width={stageWidth}
                    height={stageHeight}
                    options={{backgroundColor: 0xF0F7FF}}
                >
                    <LuckyCanvas
                        size={{width: stageWidth, height: stageHeight}}
                        store={luckyStore}
                    />
                </Stage>

                <Flex gap={10}>
                    <button type='button' className={`lucky-page_button ${!isWheel && 'disable'}`} onClick={() => {
                        luckyStore.fetchResultAndStop()
                    }}>
                        {isWheel
                            ? 'Вращать!'
                            :
                            <Flex align='center' justify='center' gap={5}><p style={{paddingTop: 3}}>Через: </p><MyTimer
                                date={wheelRemainingTime}/></Flex>
                        }
                    </button>
                    <button type='button' className='lucky-page_button lucky-page_button-mini' onClick={
                        isWheel
                            ? () => null
                            : () => handleInvite(luckyStore.referralLink, 'Мне нужна твоя помощь, участвую в рейтинге приложения Александра Овечкина. Чем выше рейтинг, тем выше шанс получать подарки. Присоединяйся тоже, давай соревноваться вместе.')
                    }>
                        {isWheel
                            ? <><span>{wheel}</span><p>{word}</p></>
                            : <img src={ImgPlus} alt="plus"/>
                        }
                    </button>
                </Flex>


                {/*
       <Modal
          title = {null}
          open={true}
          footer={null}
          closeIcon={null}
        >
        <div className='modal'>
          <div className='modal_body'>
            <img src={ImgSecret} className='modal_image' alt="img" style={{maxWidth:100}}/>
            <h3 className='modal_title'>Внимание!</h3>
            <p className='modal_text'>Во время турнира этот раздел недоступен!</p>
            <div className='modal_buttons'>
            <button type='button' className='modal_button' onClick={()=>navigate('/menu')}>В меню</button>
          </div>
          </div>

        </div>
      </Modal> */}

            </div>
        </div>
    );
});
